import { ref } from 'vue'
import api from '@/api/client'

export interface Location {
  id: number
  name: string
  active: boolean
}

export function useLocations() {
  const locations = ref<Location[]>([])
  const loading = ref(false)
  const error = ref<string | null>(null)

  const fetchLocations = async () => {
    loading.value = true
    error.value = null

    try {
      const response = await api.get<{ data: Location[] }>('/locations')
      locations.value = response.data.data.filter(loc => loc.active)
    } catch (err: any) {
      error.value = err.response?.data?.error || 'Failed to fetch locations'
      console.error('Error fetching locations:', err)
    } finally {
      loading.value = false
    }
  }

  return {
    locations,
    loading,
    error,
    fetchLocations
  }
}
